import { storage } from '../utils/tools';

import Core from '../libs/src/core';

let Auth = Core.getProvider('Auth');

export default (router) => {
    router.beforeEach((to, from, next) => {
        
        if (to.path == '/login') {
            next();
        } else {
            Auth.redirectURL = location.hash.substring(1);
            console.log('未登录',Auth.redirectURL)
            let device = storage.get('device')
            let isLogined = Auth.isLogined;
            console.log('已登录',isLogined)
            Auth.device = device;
            if (isLogined) {
                next();
            } else {
                next('/login');
            }
        }
    })
}